function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef, useEffect, useContext, useState, useImperativeHandle } from 'react';
import classNames from 'classnames';
/** @jsxRuntime classic */

/** @jsx jsx */

import { jsx } from '@emotion/core';
import useMediaQuery from '../../hooks/use-media-query';
import style from './SideMenu.style';
import '../../styles/hamburger.css';
import { ArrowRightIcon, CloseIcon } from '../../icon';
const DropDownMenuCtx = /*#__PURE__*/React.createContext();

const MenuDisclosure = () => jsx(DropDownMenuCtx.Consumer, null, ({
  toggleMenu
}) => jsx("button", {
  className: "side-disclosure hamburger",
  type: "button",
  onClick: toggleMenu
}, jsx("span", {
  className: "hamburger-box"
}, jsx("span", {
  className: "hamburger-inner"
}))));
/**
 * This component represents a menu.
 * @param {*} children All menu options.
 * @param {*} rest All other supported props.
 */


function Menu({
  children,
  ...rest
}) {
  const {
    isMenuOpen,
    toggleMenu
  } = useContext(DropDownMenuCtx);
  const wrapperRef = useRef(null);
  const menuOpenRef = useRef();
  menuOpenRef.current = isMenuOpen;
  const {
    isMobile
  } = useMediaQuery();

  const handleClickOutside = event => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target) && (typeof event.target.className === 'object' || !event.target.className.includes('hamburger'))) {
      if (menuOpenRef.current) {
        toggleMenu();
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (isMobile) {
      const navParent = document.getElementsByTagName('nav')[0].parentNode;
      const middleDiv = navParent.nextSibling;

      if (isMenuOpen) {
        middleDiv.style.display = 'none';
      } else {
        middleDiv.style.display = 'unset';
      }
    }
  }, [isMenuOpen]);
  const className = classNames('side-menu', {
    'side-menu-is-active': isMenuOpen
  });
  return jsx("div", _extends({
    className: className
  }, rest, {
    ref: wrapperRef
  }), jsx("div", {
    className: "side-menu-inner"
  }, jsx("div", {
    className: "close-menu-div"
  }, isMobile ? jsx(CloseIcon, {
    className: "close-icon",
    onClick: toggleMenu,
    css: {
      width: 15.41,
      height: 15.41,
      color: '#F93545'
    }
  }) : jsx(ArrowRightIcon, {
    className: "close-icon",
    onClick: toggleMenu,
    css: {
      color: '#F93545'
    }
  })), children));
}
/**
 * This component represents a menu item.
 * @param {*} children Menu item text.
 * @param {string} className Used to apply predetermine styles to the span of item.
 * @param {JSON} containerStyle Used to apply custom style to the item span.
 * @param {*} rest All other supported props.
 */


const MenuItem = ({
  children,
  className: cls = false,
  containerStyle,
  ...rest
}) => {
  const className = classNames('side-menu-item', {
    small: cls === 'small',
    link: cls === 'link',
    big: cls === 'big'
  });
  return jsx("span", _extends({}, rest, {
    className: className,
    style: { ...containerStyle
    }
  }), children);
};
/**
 * This component represents a menu item.
 * @param {*} children SideMenu content.
 * @param {string} SideMenuRef SideMenu ref.
 */


function SideMenu({
  children,
  SideMenuRef
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const forMeRef = useRef();
  React.useEffect(() => {
    forMeRef.current = isMenuOpen;
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!forMeRef.current);
  };

  useImperativeHandle(SideMenuRef, () => ({
    toggleMenu() {
      setIsMenuOpen(!forMeRef.current);
    }

  }));
  return jsx(DropDownMenuCtx.Provider, {
    value: {
      isMenuOpen,
      toggleMenu
    }
  }, jsx("div", {
    css: style
  }, children));
}

export { SideMenu, Menu, MenuDisclosure, MenuItem };